import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { KeyboardAvoidingView } from 'react-native';
import React, { useState, useEffect } from 'react';
import { ScrollView } from 'react-native-gesture-handler';
import i18n from 'i18n-js';
import useIsMounted from '@/hooks/mounted'
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import Footer from "@/components/basic/Footer";
import ItemInput from '@/components/basic/ItemInput';
import MediaCarousell from "@/components/media/MediaCarousell";
import { switchScreen } from '@/hooks/navigate';
import { Platform } from 'react-native';

export default function ItemEdit({ route, navigation, updateItem }) {
    const { items, idx } = route.params

    const mounted = useIsMounted()

    const [actIdx, setActIdx] = useState(idx)
    const [actItems, setActItems] = useState(items)
    const [item, setItem] = useState(actItems[actIdx] || { title: i18n.t('itemInput.title'), text: i18n.t('itemInput.text'), media: [], done: false })
    const insets = useSafeAreaInsets();

    const actions = [
        { icon: 'keyboard-arrow-up', text: idx == 0 ? 'footer.backStep' : 'footer.prevItem', component: idx == 0 ? 'BACK' : 'ItemEdit', params: { idx: idx - 1 } },
        { icon: 'home', text: 'footer.home', component: 'Home' },
        { icon: idx >= actItems.length - 1 ? 'check' : 'keyboard-arrow-down', text: idx >= actItems.length - 1 ? 'footer.create' : 'footer.nextItem', component: idx >= actItems.length - 1 ? 'BACK' : 'ItemEdit', params: { idx: idx + 1 } }
    ]

    const updateMedia = uris => {
        setItem(prevItem => (
            { ...prevItem, media: uris }
        ))
    }

    const updateTitle = text => {
        setItem(prevItem => (
            { ...prevItem, title: text }
        ))
    }

    const updateText = text => {
        setItem(prevItem => (
            { ...prevItem, text: text }
        ))
    }

    // displayed idx changed => update of local state 
    useEffect(() => {
        if (idx != actIdx) {
            console.log('idx changed, save local items', actIdx, idx)
            // Update current item
            updateItem(item, actIdx)
            setActIdx(idx)
            setActItems(prevItems => {
                let newItems = [...prevItems]
                newItems[actIdx] = item
                return newItems
            })
            setItem(actItems[idx] || { title: i18n.t('itemInput.title'), text: i18n.t('itemInput.text'), media: [], done: false })
        }
    }, [idx])

    // displayed item changed => update of local state 
    useEffect(() => {
        navigation.setOptions({ title: i18n.t('showItemScreen.title') + ' ' + (actIdx + 1) })
        navigation.setOptions({ info: item.title })
    }, [item])

    // local state triggers update of local task state on unmount
    useEffect(() => {
        return () => {
            if (!mounted()) {
                console.log('save local item')
                updateItem(item, idx)
            }
        };
    }, [item, mounted])

    const itemEdit = () => {
        switchScreen(navigation, 'ItemEdit', { idx: idx + 1 })
    }

    const buttonAddItem = idx >= actItems.length - 1 ? { action: itemEdit, info: 'footer.newItem' } : null

    return (
        <View className="bg-secondary-50 flex-1">
            <KeyboardAvoidingView behavior={Platform.select({ android: undefined, ios: 'padding' })} >
                <ScrollView contentContainerStyle={idx >= actItems.length - 1 ? { paddingBottom: 150 + insets.bottom } : { paddingBottom: 5 + insets.bottom }}>
                    <MediaCarousell key={actIdx} uris={item.media} isEdit={true} update={updateMedia} />
                    <VStack className="mx-3 mt-3">
                        <ItemInput updateTitle={updateTitle} updateText={updateText} item={item} infoTitle='infoTitleItem' infoText='infoDescriptionItem' />
                    </VStack>
                </ScrollView>
            </KeyboardAvoidingView>
            <Footer navigation={navigation} actions={actions} button={buttonAddItem} />
        </View>
    );
}
